import { render, staticRenderFns } from "./SignaturesContainer.vue?vue&type=template&id=1ad4bd21&scoped=true&"
import script from "./SignaturesContainer.vue?vue&type=script&lang=js&"
export * from "./SignaturesContainer.vue?vue&type=script&lang=js&"
import style0 from "./SignaturesContainer.vue?vue&type=style&index=0&id=1ad4bd21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad4bd21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ad4bd21')) {
      api.createRecord('1ad4bd21', component.options)
    } else {
      api.reload('1ad4bd21', component.options)
    }
    module.hot.accept("./SignaturesContainer.vue?vue&type=template&id=1ad4bd21&scoped=true&", function () {
      api.rerender('1ad4bd21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/components/SignaturesContainer.vue"
export default component.exports